<template>
    <header class="header-nav">
      <div class="logo-container">
        <router-link to="/">
          <img src="../assets/rc_logo1.png" alt="餐馆Logo" class="logo-image">
        </router-link>
      </div>
      <nav>
        <router-link to="/" class="nav-link">Home 餐馆介绍</router-link>
        <router-link to="/full-screen-menu" class="nav-link">Menu 菜单</router-link>
        <router-link to="/reserve" class="nav-link">Kontakt 联系我们</router-link>
      </nav>
    </header>
  </template>
  
  <script>
  export default {
    name: 'HeaderNav',
  };
  </script>
  
  <style scoped>
  .header-nav {
    background-color: #c5a37c; /* 保留背景色 */
    color: white;
    width: 100%;
    position: sticky;
    top: 0;
    z-index: 100;
    display: flex;             /* 使用 Flexbox 布局 */
    align-items: center;     /* 垂直居中 */
     justify-content: space-between; /*两端对齐 */
    /* max-width: 1200px;
    margin: 0 auto; */
    padding: 0 1rem; /* 左右内边距 */
  }
  
  /* Logo 容器样式 */
  .logo-container {
      display: flex; /*必须*/
      align-items: center;/*必须*/
      /*margin-right: auto;  添加此行 */
  }
  
  .logo-image {
    height: 60px; /* 设置 Logo 高度,根据实际情况调整 */
    /* width: auto;  让宽度自动适应 */
    display: block;
    margin-right:0px; /* 可选：Logo 与文字之间添加间距 */
  }
  
  /* .header-nav nav {
    display: flex;
    align-items: center;
    
  } */
  .header-nav .main-nav { /* 更具体的选择器 */
  display: flex;
  align-items: center;
  justify-content: space-around; /* 水平居中 */
  flex-grow: 1; /* 让导航占据剩余空间 */
  /* 移除不必要的内外边距 */
  padding: 0;
  margin: 0;
}
  
  .nav-link {
    color: white;
    text-decoration: none;
    padding: 0.5rem 1rem;
    border-radius: 4px;
    transition: background-color 0.3s ease;
      margin: 0 10px; /*增加间距*/
  }
  
  .nav-link:hover,
  .nav-link.router-link-active {
    background-color: rgba(255, 255, 255, 0.2); /* 浅色半透明背景 */
  }
  
  /* 移动端适配 */
  @media (max-width: 768px) {
    .header-nav {
      padding: 0 2rem; /* 调整左右内边距 */
        justify-content: flex-start;/*左对齐*/
    }
  
    .logo-image {
      height: 30px; /* 移动端缩小 Logo */
      margin-right: 10px;/*缩小间距*/
    }
  
    .header-nav nav {
      /* flex-wrap: wrap;  不换行 */
       justify-content: flex-end;/*左对齐*/
    }
    .header-nav .main-nav { /* 更具体的选择器 */
        width: 100%; /* 占据整个宽度 */
        justify-content: space-around; /* 均匀分布 */
        flex-grow: unset; /* 取消 flex-grow */
    }
  .nav-link{
      padding: 0.5rem; /*缩小内边距*/
      margin: 0 5px;/*缩小间距*/
      font-size: 0.7rem;/*缩小字号*/
  }
  }
  </style>